import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0;
  background: #fff;
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .succes-pop-up {
    width: 60%;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    border-radius: 25px;
    margin: auto;
    padding: 3rem;
    text-align: center;
    p {
      margin: 2rem 0;
    }
  }
  @media screen and (min-width: 867px) {
    .succes-pop-up {
      width: 40%;
    }
  }
`;
